const API_BASE_URL = '/api';

// Auth functions
export const auth = {
  login: async (password: string) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Login failed');
    }
    return response.json();
  },

  verify: async (token: string) => {
    const response = await fetch(`${API_BASE_URL}/auth/verify`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.ok;
  },
};

// Helper to get auth headers
const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('adminToken');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export const api = {
  // Get all bucket list items
  getBucketListItems: async () => {
    const response = await fetch(`${API_BASE_URL}/bucketlist`);
    if (!response.ok) throw new Error('Failed to fetch bucket list items');
    return response.json();
  },

  // Create a new bucket list item
  createBucketListItem: async (item: any) => {
    const response = await fetch(`${API_BASE_URL}/bucketlist`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(item),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create bucket list item');
    }
    return response.json();
  },

  // Update a bucket list item
  updateBucketListItem: async (id: string, item: any) => {
    const response = await fetch(`${API_BASE_URL}/bucketlist/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(item),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to update bucket list item');
    }
    return response.json();
  },

  // Delete a bucket list item
  deleteBucketListItem: async (id: string) => {
    const response = await fetch(`${API_BASE_URL}/bucketlist/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to delete bucket list item');
    }
    return response.json();
  },

  // Reorder a bucket list item
  reorderBucketListItem: async (id: string, direction: 'up' | 'down') => {
    const response = await fetch(`${API_BASE_URL}/bucketlist/${id}/reorder`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify({ direction }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to reorder bucket list item');
    }
    return response.json();
  },
};
